export const useCart = () => {
  if (import.meta.server) { return }
  const route = useRoute()
  const authStore = useAuthStore()
  const cartStore = useCartStore()

  const isLoginPage = computed(() => {
    return route.name?.toString().includes('login')
  })

  watch(() => authStore.loggedIn, async () => {
    if (authStore.loggedIn && !isLoginPage.value) { // LoginForm handles cart syncing itself
      if (!cartStore.cartId) {
        await cartStore.retrieveCartId()
      }
      await cartStore.sync()
    }
    if (authStore.loggedIn === null || authStore.loggedIn === false) {
      cartStore.reset()
      cartStore.cartId = null
    }
  })
}
